import axios from 'axios'

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

export default axios.create({
  headers: {
    'Content-type': 'application/json'
  }
})
